import { render, staticRenderFns } from "./sellCard.vue?vue&type=template&id=24b80fa9&scoped=true&"
import script from "./sellCard.vue?vue&type=script&lang=js&"
export * from "./sellCard.vue?vue&type=script&lang=js&"
import style0 from "./sellCard.vue?vue&type=style&index=0&id=24b80fa9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b80fa9",
  null
  
)

export default component.exports